import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {ScriptService} from './script.service';
import {Mutation} from '../interfaces/generated/graphql';
import {ApolloService} from './apollo.service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HsFormsService {
  private scriptService = inject(ScriptService);
  private apollo = inject(ApolloService);
  private platformId = inject(PLATFORM_ID);

  addEmbedForm(portalId: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    return this.scriptService.addScript({
      type: 'text/javascript',
      src: `https://js.hsforms.net/forms/embed/${portalId}.js`
    })
  }

  async addForm(portalId: string, formId: string, target: string) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    await this.scriptService.addScript({
      type: 'text/javascript',
      src: '//js.hsforms.net/forms/v2.js'
    })
    this.hbspt.forms.create({
      portalId,
      formId,
      target
    });
  }
  get hbspt() {
    if (isPlatformBrowser(this.platformId)) {
      return (window as any).hbspt;
    }
    return null;
  }

  submitHubspotFormEvent(formName: string, data: string) {
    return this.apollo.mutatePromise<Mutation>({
      queryName: 'hubspotFormEventMutation',
      variables: {
        formName,
        data
      }
    });
  }

}
